function initializeCookiePopupEvent(event) {
  var targetSectionId = event && event.detail && event.detail.sectionId;
  var cookieConsentPopupWrapper = document.querySelector('.cookie-consent-popup-wrapper');
  var cookieConsentSectionId = cookieConsentPopupWrapper ? cookieConsentPopupWrapper.getAttribute('data-section-id') : null;
  
  if (!targetSectionId || targetSectionId === cookieConsentSectionId) {
    initializeCookiePopup();
  }
}

function initializeCookiePopup() {

  var popupElement = document.querySelector('.cookie-consent-popup-wrapper');
  if (popupElement) {
    cookieConsentPopupSettings.testMode = popupElement.getAttribute('data-test-mode');
  }

  var consentEnabled = cookieConsentPopupSettings.consentEnabled;
  var testMode = cookieConsentPopupSettings.testMode;
  var delay = cookieConsentPopupSettings.delay;  

  // Set a cookie
  function setCookie(name, value, days) {
    var expires = "";
    if (days) {
      var date = new Date();
      date.setTime(date.getTime() + (days * 24 * 60 * 60 * 1000));
      expires = "; expires=" + date.toUTCString();
    }
    document.cookie = name + "=" + (value || "") + expires + "; path=/";
  }

  function getCookie(name) {
    var nameEQ = name + "=";
    var ca = document.cookie.split(';');
    for (var i = 0; i < ca.length; i++) {
      var c = ca[i];
      while (c.charAt(0) === ' ') c = c.substring(1, c.length);
      if (c.indexOf(nameEQ) == 0) return c.substring(nameEQ.length, c.length);
    }
    return null;
  }

  // Show the cookie consent popup
  function showCookieConsentPopup() {
    var popup = document.querySelector('.cookie-consent-popup-wrapper');
    if (popup) {
      popup.style.display = 'flex';
    }
  }

  // Hide popup
  function hideCookieConsentPopup() {
    var popup = document.querySelector('.cookie-consent-popup-wrapper');
    if (popup) {
      popup.style.display = 'none';
    }
  }

  // Check if the user has already made a decision on the cookie consent
  var cookieConsent = getCookie('cookieConsent');

  if (testMode == 'true') {
  // Show the popup with a delay if specified
    showCookieConsentPopup();
  } else if (!cookieConsent && consentEnabled === true && !(Shopify && Shopify.designMode))  {
    setTimeout(showCookieConsentPopup, delay * 1000);
  }
  
  // Event listener for the 'Accept' button
  var acceptButton = document.querySelector('.cookie-consent-accept-btn');
  if (acceptButton) {
    acceptButton.addEventListener('click', function() {
      setCookie('cookieConsent', 'accepted', 365);
      // Set cookie for 1 year
      hideCookieConsentPopup();
    });
  }

  // Event listener for the 'Decline' button
  var declineButton = document.querySelector('.cookie-consent-decline-btn');
  if (declineButton) {
    declineButton.addEventListener('click', function() {
      setCookie('cookieConsent', 'declined', 365); // Set cookie for 1 year
      hideCookieConsentPopup();
    });
  }
}

// Initialize on DOMContentLoaded
document.addEventListener("DOMContentLoaded", initializeCookiePopup);

// Reinitialize on Shopify's theme editor events
document.addEventListener('shopify:section:load', initializeCookiePopupEvent);
document.addEventListener('shopify:section:unload', initializeCookiePopupEvent);
document.addEventListener('shopify:block:select', initializeCookiePopupEvent);
document.addEventListener('shopify:block:deselect', initializeCookiePopupEvent);